// Module
var code = `<ex-multi-occurrence-analyse multi-occurrence-options="vm.jrsMultiOccurrenceOptions"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;